var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3,
    y1: 11.7,
    x2: 21,
    y2: 11.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e0fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1107fe"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,6.4l-8-4.4-8,4.4,5.1,2.8c.7-.8,1.8-1.2,2.9-1.2s2.2.5,2.9,1.2l5.1-2.8ZM10,12c0-1.1.9-2,2-2s2,.9,2,2-.9,2-2,2-2-.9-2-2M11,21.4l-8-4.4v-8.9l5.1,2.8c0,.3-.1.7-.1,1,0,1.9,1.3,3.4,3,3.9v5.6ZM13,21.4v-5.6c1.7-.4,3-2,3-3.9s0-.7-.1-1l5.1-2.8v8.9l-8,4.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtd);
export default __webpack_public_path__ + "static/media/atd.1ff6f3f65e7887f4786a7f085b2546bd.svg";
export { ForwardRef as ReactComponent };